import { render, staticRenderFns } from "./ContactConversations.vue?vue&type=template&id=50b18a7e&scoped=true&"
import script from "./ContactConversations.vue?vue&type=script&lang=js&"
export * from "./ContactConversations.vue?vue&type=script&lang=js&"
import style0 from "./ContactConversations.vue?vue&type=style&index=0&id=50b18a7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50b18a7e",
  null
  
)

export default component.exports